import { IconProps } from './types';

const BotIcon = (props: IconProps) => {
  const { width = 16, height = 16, fillColor = 'var(--charcoal-grey)' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2.7998 6.80019C2.7998 5.91654 3.51615 5.2002 4.3998 5.2002H11.5998C12.4835 5.2002 13.1998 5.91654 13.1998 6.8002V13.2002C13.1998 14.0839 12.4835 14.8002 11.5998 14.8002H4.39981C3.51615 14.8002 2.7998 14.0839 2.7998 13.2002V6.80019Z"
        stroke={fillColor}
        strokeWidth="0.8"
      />
      <path
        d="M2.7998 7.6001H1.99981C1.55798 7.6001 1.1998 7.95827 1.1998 8.4001V11.6001C1.1998 12.0419 1.55798 12.4001 1.9998 12.4001H2.7998V7.6001Z"
        stroke={fillColor}
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      <path
        d="M14.7998 8.4001C14.7998 7.95827 14.4416 7.6001 13.9998 7.6001H13.1998V12.4001H13.9998C14.4416 12.4001 14.7998 12.0419 14.7998 11.6001V8.4001Z"
        stroke={fillColor}
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      <circle cx="6" cy="10" r="1" fill={fillColor} />
      <circle cx="10" cy="10" r="1" fill={fillColor} />
      <path d="M8 3.6001L8 5.2001" stroke={fillColor} strokeWidth="0.8" strokeLinecap="round" />
      <circle cx="7.9998" cy="2.4002" r="1.2" stroke={fillColor} strokeWidth="0.8" />
    </svg>
  );
};

export default BotIcon;
